import { z } from 'zod';
import { ImageSchema } from '~entities/image/model/image.contracts';

export const RoomFeatureSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  svg: z.string(),
});

export const RoomSchema = z.object({
  id: z.number().int(),
  sort: z.number().int(),
  name: z.string(),
  subtitle: z.string().optional(),
  teaser: z.string().optional(),
  description: z.string().optional(),
  size: z.string().optional(),
  images: z.array(ImageSchema),
  minimumOccupancy: z.number().int(),
  maximumOccupancy: z.number().int(),
  features: z.array(RoomFeatureSchema),
  descriptions: z.array(
    z.object({
      id: z.number().int(),
      type: z.string(),
      text: z.string(),
    }),
  ),
});
